import { GoogleMapsAutocompleteResult, GoogleMapsPlaceDetails } from '@business/entities/integration';
import { Endpoint } from '../endpoint';

export function getAutocomplete(input: string) {
  return Endpoint.get<GoogleMapsAutocompleteResult[]>('@gc/google-maps/autocomplete', { params: { input } });
}

export function getPlaceDetails(placeId: string) {
  return Endpoint.get<GoogleMapsPlaceDetails>('@gc/google-maps/place-details', { params: { placeId } });
}
